import React, { useState } from 'react';
import { Link } from 'react-router';
import { useQuery, useQueryClient } from 'react-query';
import RaisedButton from 'material-ui/RaisedButton';
import LinearProgress from 'material-ui/LinearProgress';
import {
    Table,
    TableBody,
    TableHeader,
    TableHeaderColumn,
    TableRow,
    TableRowColumn,
} from 'material-ui/Table';
import { listCorpora } from 'services/testRuns';
import ProposeCompositionDialog from './ProposeCompositionDialog';
import './styles.scss';

function formatDate(value) {
    if (!value) {
        return '—';
    }
    const date = new Date(value);
    return Number.isNaN(date.getTime()) ? '—' : date.toLocaleString();
}

export default function CorporaListPage({ router }) {
    const queryClient = useQueryClient();
    const [proposeOpen, setProposeOpen] = useState(false);
    const { data, error, isLoading } = useQuery('bbr-corpora', listCorpora);
    const rows = Array.isArray(data) ? data : [];

    return (
        <div className="test-runs-page">
            <div className="test-runs-toolbar">
                <h2>Corporas</h2>
                <span>
                    <RaisedButton
                        label="New from coverage"
                        onClick={() => setProposeOpen(true)}
                        style={{ marginRight: 12 }}
                    />
                    <RaisedButton
                        primary
                        label="Create corpus"
                        onClick={() => router.push('/bbr/corporas/new')}
                    />
                </span>
            </div>
            {error && <div className="test-runs-error">{error.message}</div>}
            {isLoading && <LinearProgress />}
            <Table selectable={false}>
                <TableHeader displaySelectAll={false} adjustForCheckbox={false}>
                    <TableRow>
                        <TableHeaderColumn>Name</TableHeaderColumn>
                        <TableHeaderColumn>Created</TableHeaderColumn>
                        <TableHeaderColumn>Last run</TableHeaderColumn>
                        <TableHeaderColumn>Documents</TableHeaderColumn>
                        <TableHeaderColumn>Runs</TableHeaderColumn>
                    </TableRow>
                </TableHeader>
                <TableBody displayRowCheckbox={false}>
                    {rows.map((row) => (
                        <TableRow key={row._id}>
                            <TableRowColumn>
                                <Link to={`/bbr/corporas/${row._id}`}>{row.name}</Link>
                            </TableRowColumn>
                            <TableRowColumn>{formatDate(row.createdAt)}</TableRowColumn>
                            <TableRowColumn>
                                {row.lastRunId ? (
                                    <Link to={`/bbr/runs/${row.lastRunId}`}>{formatDate(row.lastRunAt)}</Link>
                                ) : (
                                    '—'
                                )}
                            </TableRowColumn>
                            <TableRowColumn>{row.mailCount || 0}</TableRowColumn>
                            <TableRowColumn>{row.runsCount || 0}</TableRowColumn>
                        </TableRow>
                    ))}
                </TableBody>
            </Table>
            {!isLoading && rows.length === 0 && (
                <p className="test-runs-hint">No corporas yet. Create one to start collecting documents.</p>
            )}
            <ProposeCompositionDialog
                open={proposeOpen}
                onClose={() => setProposeOpen(false)}
                onCreated={(created) => {
                    queryClient.invalidateQueries('bbr-corpora');
                    if (created && created._id) {
                        router.push(`/bbr/corporas/${created._id}`);
                    }
                }}
            />
        </div>
    );
}



// WEBPACK FOOTER //
// ./app/components/TestRuns/CorporaListPage.jsx